/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiConversionStateFromJSON, ApiConversionStateToJSON, } from './ApiConversionState';
import { ApiConversionTypeFromJSON, ApiConversionTypeToJSON, } from './ApiConversionType';
import { ApiLocationSimplifiedFromJSON, ApiLocationSimplifiedToJSON, } from './ApiLocationSimplified';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
import { ApiProjectDefaultFromJSON, ApiProjectDefaultToJSON, } from './ApiProjectDefault';
import { ApiReservedConversionFromJSON, ApiReservedConversionToJSON, } from './ApiReservedConversion';
export function ApiConversionFromJSON(json) {
    return ApiConversionFromJSONTyped(json, false);
}
export function ApiConversionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        '_default': !exists(json, 'default') ? undefined : ApiProjectDefaultFromJSON(json['default']),
        'deletedAt': !exists(json, 'deletedAt') ? undefined : (new Date(json['deletedAt'])),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lastFiredAt': !exists(json, 'lastFiredAt') ? undefined : (new Date(json['lastFiredAt'])),
        'locations': !exists(json, 'locations') ? undefined : (json['locations'].map(ApiLocationSimplifiedFromJSON)),
        'metaMatchQuality': !exists(json, 'metaMatchQuality') ? undefined : json['metaMatchQuality'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'pushToMeta': !exists(json, 'pushToMeta') ? undefined : json['pushToMeta'],
        'reserved': !exists(json, 'reserved') ? undefined : ApiReservedConversionFromJSON(json['reserved']),
        'states': !exists(json, 'states') ? undefined : (json['states'].map(ApiConversionStateFromJSON)),
        'type': !exists(json, 'type') ? undefined : ApiConversionTypeFromJSON(json['type']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiConversionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'default': ApiProjectDefaultToJSON(value._default),
        'deletedAt': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'id': value.id,
        'lastFiredAt': value.lastFiredAt === undefined ? undefined : (value.lastFiredAt.toISOString()),
        'locations': value.locations === undefined ? undefined : (value.locations.map(ApiLocationSimplifiedToJSON)),
        'metaMatchQuality': value.metaMatchQuality,
        'name': value.name,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'pushToMeta': value.pushToMeta,
        'reserved': ApiReservedConversionToJSON(value.reserved),
        'states': value.states === undefined ? undefined : (value.states.map(ApiConversionStateToJSON)),
        'type': ApiConversionTypeToJSON(value.type),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
